import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendAnalyticsSessionLog } from '../../utils/analytics';

const CLICK_TARGET_SELECTOR = '[data-analytics-id]';
const TOGGLE_TARGET_SELECTOR = 'input[type="checkbox"], [role="switch"]';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    sendAnalyticsSessionLog({
      eventName: 'page_view',
      payload: {
        path: location.pathname,
        search: location.search,
        hash: location.hash
      }
    });
  }, [location.hash, location.pathname, location.search]);

  useEffect(() => {
    const onTrackedClick = event => {
      const clickTarget = event.target?.closest?.(CLICK_TARGET_SELECTOR);

      if (!clickTarget) {
        return;
      }

      sendAnalyticsSessionLog({
        eventName: 'click',
        payload: {
          cta_id: clickTarget.dataset.analyticsId,
          cta_text: clickTarget.textContent?.trim()?.slice(0, 120) || '',
          path: window.location.pathname
        }
      });
    };

    document.addEventListener('click', onTrackedClick);

    return () => {
      document.removeEventListener('click', onTrackedClick);
    };
  }, []);

  useEffect(() => {
    const onToggleChange = event => {
      const toggleTarget = event.target?.closest?.(TOGGLE_TARGET_SELECTOR);

      if (!toggleTarget) {
        return;
      }

      const toggleId =
        toggleTarget.dataset.analyticsId ||
        toggleTarget.id ||
        toggleTarget.name ||
        'unnamed_toggle';

      const isChecked =
        typeof toggleTarget.checked === 'boolean'
          ? toggleTarget.checked
          : toggleTarget.getAttribute('aria-checked') === 'true';

      sendAnalyticsSessionLog({
        eventName: 'toggle',
        payload: {
          cta_id: `toggle_${toggleId}`,
          cta_text: toggleTarget.getAttribute('aria-label') || '',
          path: window.location.pathname,
          toggle_value: isChecked
        }
      });
    };

    document.addEventListener('change', onToggleChange);

    return () => {
      document.removeEventListener('change', onToggleChange);
    };
  }, []);

  return null;
};

export default AnalyticsTracker;
